/**
 * Test IDs for QA automation.
 */
export const testIds = {
  maintenanceTasksListPendingNavigation: "maintenance-tasks-list-pending-navigation",
  maintenanceTasksListPendingView: "maintenance-tasks-list-pending-view",
  maintenanceTasksListCompleted: "maintenance-tasks-list-completed",
  maintenanceTasksListCreateTask: "maintenance-tasks-list-create-task",
} as const;
